import GitInfo from 'react-git-info/macro'

const gitInfo = GitInfo()

let confProp
if (process.env.REACT_APP_TARGET === 'production') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://api.officemail.io/v1',
      restURL: 'https://chat.rework.so',
      URL: 'https://api.officemail.io/graphql',
      wsAddress: 'chat-websocket.rework.so',
      wsURL: null,
    },
  }
} else if (process.env.REACT_APP_TARGET === 'test') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev-api.officemail.io/v1',
      // restURL: 'http://localhost:4030',
      restURL: 'https://dev.chat.rework.so',
      wsAddress: 'dev.chat.rework.so',
      URL: 'https://dev-api.officemail.io/graphql',
      wsURL: null,
    },
  }
} else if (process.env.REACT_APP_TARGET === 'test1') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restLandigURL: 'https://dev-api.officemail.io/v1',
      // restURL: 'http://localhost:4030',
      restURL: 'http://192.168.50.100:8000',
      wsAddress: '192.168.50.100:8000',
      URL: null,
      wsURL: null,
    },
  }
} else if (process.env.REACT_APP_TARGET === 'log') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restURL: 'https://dev-api.officemail.io/v1',
      URL: 'http://192.168.50.102:9051/graphql',
      wsURL: 'ws://192.168.50.102:9051/graphql',
    },
  }
} else if (process.env.REACT_APP_TARGET === 'log2') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restURL: 'https://dev-api.officemail.io/v1',
      URL: 'http://192.168.50.102:9051/graphql',
      wsURL: 'ws://192.168.50.102:9051/graphql',
    },
  }
} else {
  confProp = {
    DEBUG: true,
    SERVER: {
      restURL: 'http://localhost:8001/v1',
      URL: 'http://localhost:8001/__admin/graphql',
      wsURL: 'ws://localhost:8002/graphql/',
    },
  }
}

confProp.defaultLocale = 'en-US' // 'ko-KR'

if (window.globalConfig != null) {
  if (window.globalConfig.restURL != null) {
    confProp.SERVER.restURL = window.globalConfig.restURL
  }
  if (window.globalConfig.URL != null) {
    confProp.SERVER.URL = window.globalConfig.URL
  }
  if (window.globalConfig.wsURL != null) {
    confProp.SERVER.wsURL = window.globalConfig.wsURL
  }
  if (window.globalConfig.LOCALE != null) {
    confProp.defaultLocale = window.globalConfig.LOCALE
  }
}

confProp.gitInfo = gitInfo

const conf = confProp

export default conf
